export const BRAND_OPTIONS = {
  Volkswagen: "Volkswagen",
  VolkswagenNutzfahrzeuge: "Volkswagen Nutzfahrzeuge",
  Audi: "Audi",
};
export type ManufacturerKey = keyof typeof BRAND_OPTIONS;